export const emailList = {
  overviews: [
    {
      id: 1,
      name: "Total Email",
      count: "50,545",
      icon: "bi-envelope",
      color: "primary"
    },
    {
      id: 2,
      name: "Email Sent",
      count: "25,000",
      icon: "bi-envelope-plus",
      color: "warning"
    },
    {
      id: 3,
      name: "Emais Delivered",
      count: "20,354",
      icon: "bi-envelope-check",
      color: "success"
    },
    {
      id: 4,
      name: "Email Opened",
      count: "12,422",
      icon: "bi-envelope-open",
      color: "indigo"
    },
    {
      id: 5,
      name: "Email Clicked",
      count: "6,248",
      icon: "bi-envelope-heart",
      color: "teal"
    },
    {
      id: 6,
      name: "Email Bounce",
      count: "2,047",
      icon: "bi-envelope-slash",
      color: "danger"
    }
  ],
  emails: [
    {
      id: '1fcb',
      user_img: "/images/avatar/2.png",
      user_name: "Archie Cantones",
      user_email: "arcie.tones@gmail.com",
      labels: "Friends",
      subject: "Ruhul Hasan, log into Facebook with one click",
      date: "11 May, 2024",
      is_active: "active",
      active_time: "2 min ago",
      is_message_read: false
    },

    {
      id: '2bcb',
      user_img: "",
      user_name: "Holmes Cherryman",
      user_email: "golms.chan@gmail.com",
      labels: "Update",
      subject: "Latest news updates on your subscribed channel",
      date: "12 May, 2024",
      is_active: "always",
      active_time: "5 min ago",
      is_message_read: false
    },
    {
      id: '3fcb',
      user_img: "/images/avatar/4.png",
      user_name: "Malanie Hanvey",
      user_email: "lanie.nveyn@gmail.com",
      labels: "Primary",
      subject: "Flatlogic Contact Form: I am requesting to submit a template",
      date: "12 May, 2024",
      is_active: "active",
      active_time: "7 min ago",
      is_message_read: true
    },
    {
      id: '4ecb',
      user_img: "",
      user_name: "Kenneth Hune",
      user_email: "nneth.une@gmail.com",
      labels: "Not Interested",
      subject: "Ruhul Hasan, log into Facebook with one click",
      date: "13 May, 2024",
      is_active: "active",
      active_time: "9 min ago",
      is_message_read: true
    },
    {
      id: '5fpc',
      user_img: "/images/avatar/6.png",
      user_name: "Valentine Maton",
      user_email: "alenine.aton@gmail.com",
      labels: "Completed",
      subject: "Latest news updates on your subscribed channel",
      date: "14 May, 2024",
      is_active: "inactive",
      active_time: "10 min ago",
      is_message_read: true
    },
    {
      id: '6plc',
      user_img: "/images/avatar/3.png",
      user_name: "Bryan Waters",
      user_email: "nneth.une@gmail.com",
      labels: "Not Interested",
      subject: "Flatlogic Contact Form: I am requesting to submit a template",
      date: "14 May, 2024",
      is_active: "active",
      active_time: "9 min ago",
      is_message_read: true
    },
    {
      id: '7dmp',
      user_img: "/images/avatar/5.png",
      user_name: "Valentine Maton",
      user_email: "alenine.aton@gmail.com",
      labels: "Completed",
      subject: "Ruhul Hasan, log into Facebook with one click",
      date: "14 May, 2024",
      is_active: "active",
      active_time: "10 min ago",
      is_message_read: true
    },
    {
      id: '8sdb',
      user_img: "/images/avatar/10.png",
      user_name: "Kenneth Hune",
      user_email: "nneth.une@gmail.com",
      labels: "Not Interested",
      subject: "Latest news updates on your subscribed channel",
      date: "15 May, 2024",
      is_active: "active",
      active_time: "9 min ago",
      is_message_read: true
    },
    {
      id: '9ssd',
      user_img: "/images/avatar/11.png",
      user_name: "Ursula Sanders",
      user_email: "alenine.aton@gmail.com",
      labels: "Completed",
      subject: "Flatlogic Contact Form: I am requesting to submit a template",
      date: "15 May, 2024",
      is_active: "active",
      active_time: "17 min ago",
      is_message_read: true
    },
    {
      id: '10hdd',
      user_img: "",
      user_name: "Timothy Boyd",
      user_email: "alenine.aton@gmail.com",
      labels: "Completed",
      subject: "Ruhul Hasan, log into Facebook with one click",
      date: "16 May, 2024",
      is_active: "active",
      active_time: "16 min ago",
      is_message_read: true
    },
    {
      id: '11mcb',
      user_img: "/images/avatar/2.png",
      user_name: "Archie Cantones",
      user_email: "arcie.tones@gmail.com",
      labels: "Friends",
      subject: "Ruhul Hasan, log into Facebook with one click",
      date: "17 May, 2024",
      is_active: "active",
      active_time: "2 min ago",
      is_message_read: false
    },

    {
      id: '12blc',
      user_img: "",
      user_name: "Holmes Cherryman",
      user_email: "golms.chan@gmail.com",
      labels: "Update",
      subject: "Latest news updates on your subscribed channel",
      date: "18 May, 2024",
      is_active: "always",
      active_time: "5 min ago",
      is_message_read: false
    },
  ],

  prevSentEmail: [
    {
      id: "collapseOne",
      user_img: "/images/avatar/1.png",
      user_email: "mar.audrey@gmail.com",
      user_name: "Alexandra Della",
      date: "27 May, 2023",
      message: `
            <p>Hey, Audrey!</p>
            <p>
                It is a long established fact that a reader will be distracted by
                the readable content of a page when looking at its layout.
            </p>
            <p>
                The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution of letters, as opposed to using "Content here,
                content here", making it look like readable English.
            </p>
            <p>
                Many desktop publishing packages and web page editors now use
                Lorem Ipsum as their default model text, and a search for "lorem
                ipsum" will uncover many web sites still in their infancy.
            </p>
            <p>
                Various versions have evolved over the years, sometimes by
                accident, sometimes on purpose (injected humour and the like).
            </p>
            <br />
            <p className="mb-0">Looking forward to hearing from you!</p>
            <div className="fs-12">
                Thanks by, <a href="">Alex</a>
            </div>
            `,

      details: `
            <ul class="list-unstyled mb-0">
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> from: </span>
                <span class="fs-12 d-inline-block text-dark"> no-reply@google.com </span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> to: </span>
                <span class="fs-12 d-inline-block text-dark">wrapcode.info@gmail.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> bcc: </span>
                <span class="fs-12 d-inline-block text-dark">wrapcode.info@gmail.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> date: </span>
                <span class="fs-12 d-inline-block text-dark">Oct 18, 2022, 12:01 PM</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> subject: </span>
                <span class="fs-12 d-inline-block text-dark"> Security alert for Account </span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> mailed: </span>
                <span class="fs-12 d-inline-block text-dark">gaia.bounces.google.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> singed: </span>
                <span class="fs-12 d-inline-block text-dark">accounts.google.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> security: </span>
                <span class="fs-12 d-inline-block text-dark"> Standard encryption (TLS) </span>
              </li>
            </ul>
          `
    },

    {
      id: "collapseTwo",
      user_img: "/images/avatar/5.png",
      user_email: "alex.della@outlook.com",
      user_name: "Marianne Audrey",
      date: "26 May, 2023",
      message: `
            <p>Hey, Audrey!</p>
            <p>
                It is a long established fact that a reader will be distracted by
                the readable content of a page when looking at its layout.
            </p>
            <p>
                The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution of letters, as opposed to using "Content here,
                content here", making it look like readable English.
            </p>
            <p>
                Many desktop publishing packages and web page editors now use
                Lorem Ipsum as their default model text, and a search for "lorem
                ipsum" will uncover many web sites still in their infancy.
            </p>
            <p>
                Various versions have evolved over the years, sometimes by
                accident, sometimes on purpose (injected humour and the like).
            </p>
            <br />
            <p className="mb-0">Looking forward to hearing from you!</p>
            <div className="fs-12">
                Thanks by, <a href="">Alex</a>
            </div>
            `,

      details: `
            <ul class="list-unstyled mb-0">
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> from: </span>
                <span class="fs-12 d-inline-block text-dark"> no-reply@google.com </span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> to: </span>
                <span class="fs-12 d-inline-block text-dark">wrapcode.info@gmail.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> bcc: </span>
                <span class="fs-12 d-inline-block text-dark">wrapcode.info@gmail.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> date: </span>
                <span class="fs-12 d-inline-block text-dark">Oct 18, 2022, 12:01 PM</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> subject: </span>
                <span class="fs-12 d-inline-block text-dark"> Security alert for Account </span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> mailed: </span>
                <span class="fs-12 d-inline-block text-dark">gaia.bounces.google.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> singed: </span>
                <span class="fs-12 d-inline-block text-dark">accounts.google.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> security: </span>
                <span class="fs-12 d-inline-block text-dark"> Standard encryption (TLS) </span>
              </li>
            </ul>
          `
    },

    {
      id: "collapseThree",
      user_img: "/images/avatar/3.png",
      user_email: "mar.audrey@gmail.com",
      user_name: "Alexandra Della",
      date: "25 May, 2023",
      message: `
            <p>Hey, Audrey!</p>
            <p>
                It is a long established fact that a reader will be distracted by
                the readable content of a page when looking at its layout.
            </p>
            <p>
                The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution of letters, as opposed to using "Content here,
                content here", making it look like readable English.
            </p>
            <p>
                Many desktop publishing packages and web page editors now use
                Lorem Ipsum as their default model text, and a search for "lorem
                ipsum" will uncover many web sites still in their infancy.
            </p>
            <p>
                Various versions have evolved over the years, sometimes by
                accident, sometimes on purpose (injected humour and the like).
            </p>
            <br />
            <p className="mb-0">Looking forward to hearing from you!</p>
            <div className="fs-12">
                Thanks by, <a href="">Alex</a>
            </div>
            `,

      details: `
            <ul class="list-unstyled mb-0">
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> from: </span>
                <span class="fs-12 d-inline-block text-dark"> no-reply@google.com </span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> to: </span>
                <span class="fs-12 d-inline-block text-dark">wrapcode.info@gmail.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> bcc: </span>
                <span class="fs-12 d-inline-block text-dark">wrapcode.info@gmail.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> date: </span>
                <span class="fs-12 d-inline-block text-dark">Oct 18, 2022, 12:01 PM</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> subject: </span>
                <span class="fs-12 d-inline-block text-dark"> Security alert for Account </span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> mailed: </span>
                <span class="fs-12 d-inline-block text-dark">gaia.bounces.google.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> singed: </span>
                <span class="fs-12 d-inline-block text-dark">accounts.google.com</span>
              </li>
              <li class="mb-1">
                <span class="d-inline-block wd-50 text-muted text-end fs-12 me-3"> security: </span>
                <span class="fs-12 d-inline-block text-dark"> Standard encryption (TLS) </span>
              </li>
            </ul>
          `
    },

  ]
}

